import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export class TmApiSessionRejectedError extends TmApiValidationError {
  public name = 'TmApiSessionRejectedError'
}
